<template>
  <div>
    <!-- search -->
    <search
      @getSystemList="getSystemList"
    ></search>
    <!-- list view -->
    <el-row>
      <el-button size="small" icon="el-hg-icon-detail" @click="detail">详情</el-button>
    </el-row>
    <list :dataList.sync="aDataList" @detail="detail" ref="tableList"/>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- dialogs -->
    <my-dialog :show="bShowDialog" @close="closeDialog" :form-data.sync="formData"></my-dialog>
  </div>
</template>
<script>
import search from './search';
import list from './list';
import MyDialog from './dialog';

export default {
  name: 'behaviorDiary',
  components: {
    search,
    list,
    MyDialog
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        currentPage: 1
      },
      aDataList: [],
      total: 0,
      formData: {},
      bShowDialog: false
    };
  },
  methods: {
    async getSystemList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      const res = await this.$services.postLoading({
        type: 'INTERFACELOG',
        url: 'getPortLogList',
        params: this.queryParams
      });
      this.aDataList = res.bean.list;
      this.total = res.bean.total;
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getSystemList();
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getSystemList();
    },
    detail() {
      this.formData = this.getCheckItems();
      this.bShowDialog = true;
    },
    getCheckItems() {
      let obj = {};
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          obj = item
        }
      }
      return obj;
    },
    closeDialog() {
      this.bShowDialog = false;
      this.clearChecked();
    },
    clearChecked() {
      console.warn('clear checked!');
      // table ref
      this.$refs['tableList'].$refs['multipleTable'].clearSelection();
    }
  },
  created() {
    this.getSystemList();
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}
/*.operation-box{*/
/*padding:10px;*/
/*background: #F1F9FB;*/
/*}*/
</style>
